<template>
  <li class="dom-table-item" @mouseover="hoverSpan" @mouseout="leaveSpan">
    <span
      data-type="order-buy"
      :class="{ hover: holding.bid }"
      @click="cancelOrder($event, 'bid')"
    >{{ orderBuy ? $t('trade.dom.cancel') : holding.bid || '' }}</span
    >
    <span
      :style="bidBgStyle"
      :class="{ tradable: isTradable }"
      data-type="order-bid"
      @click.stop="tradeStock('LMT_BUY')"
    >
      {{ orderBid ? $t('trade.dom.buy-limit') : bidVolume }}</span
    >
    <span
      :class="{ 'cur-price': isActive, 'cost-price': +data.price === cost }"
      :style="priceBgStyle"
    >{{ data.price }}</span
    >
    <span
      :style="askBgStyle"
      :class="{ tradable: isTradable }"
      data-type="order-ask"
      @click.stop="tradeStock('LMT_SELL')"
    >
      {{ orderAsk ? $t('trade.dom.sell-limit') : askVolume }}</span
    >
    <span
      data-type="order-sell"
      :class="{ hover: holding.ask }"
      @click="cancelOrder($event, 'ask')"
    >{{ orderSell ? $t('trade.dom.cancel') : holding.ask || '' }}</span
    >
  </li>
</template>
<script>
import { ORDER_TYPE } from 'const/trade'
export default {
  name: '',
  props: {
    data: {
      type: Object,
      default: function() {
        return {}
      }
    },
    cost: Number,
    orderMap: Object,
    priceMap: {
      type: Object,
      default: function() {
        return {}
      }
    },
    isActive: Boolean,
    isTradable: Boolean
  },
  computed: {
    priceBgStyle() {
      const { maxBidPrice, minAskPrice } = this.priceMap
      const { price } = this.data
      if (maxBidPrice === 0 || minAskPrice === 0) return

      if (+price <= maxBidPrice) {
        return {
          backgroundColor: 'rgba(255,93,33,0.05)'
        }
      }
      if (+price >= minAskPrice) {
        return {
          backgroundColor: 'rgba(33,141,242,0.05)'
        }
      }
    },
    bidBgStyle() {
      const { type, volume } = this.data
      const bidVolume = type === 'bid' ? volume : 0
      const percentage = (bidVolume / this.priceMap.maxBidVolume) * 100
      if (!percentage) return {}
      const end =
        percentage === 100
          ? `rgba(255,93,33,0.5) ${percentage}%`
          : `rgba(255,93,33,0.5) ${percentage}%, transparent ${percentage}%, transparent 100%`
      return {
        backgroundImage: `linear-gradient(to left, rgba(255,93,33,0.5) 0, ${end})`
      }
    },
    askBgStyle() {
      const { type, volume } = this.data
      const askVolume = type === 'ask' ? volume : 0
      const percentage = (askVolume / this.priceMap.maxAskVolume) * 100
      if (!percentage) return {}
      const end =
        percentage === 100
          ? `rgba(33,141,242,0.5) ${percentage}%`
          : `rgba(33,141,242,0.5) ${percentage}%, transparent ${percentage}%, transparent 100%`
      return {
        backgroundImage: `linear-gradient(to right, rgba(33,141,242,0.5) 0, ${end})`
      }
    },
    formatVolume() {
      if (this.data.volume) {
        if (this.data.volume > 1000) {
          return (this.data.volume / 1000).toFixed(2) + 'K'
        }
        return this.data.volume
      }
      return ''
    },
    holding() {
      return this.orderMap[+this.data.price] || {}
    },
    bidVolume() {
      return this.data.type === 'bid' ? this.formatVolume : ''
    },
    askVolume() {
      return this.data.type === 'ask' ? this.formatVolume : ''
    }
  },
  data() {
    return {
      orderBuy: false,
      orderBid: false,
      orderSell: false,
      orderAsk: false
    }
  },
  methods: {
    toCamel(str) {
      return str.replace(/-\w/, function(match) {
        return match.slice(1).toUpperCase()
      })
    },
    toggleTextFlag(type, flag) {
      const map = {
        'order-buy': 'orderBuy',
        'order-bid': 'orderBid',
        'order-sell': 'orderSell',
        'order-ask': 'orderAsk'
      }
      this[map[type]] = flag
    },
    hoverSpan(ev) {
      const type = ev.target.dataset.type
      if (!type || !this.isTradable) return
      // 没有挂单不显示
      if (type === 'order-buy' && !this.holding.bid) return
      if (type === 'order-sell' && !this.holding.ask) return
      this.toggleTextFlag(type, true)
    },
    leaveSpan(ev) {
      const type = ev.target.dataset.type
      if (!type) return
      this.toggleTextFlag(type, false)
    },
    cancelOrder(ev, type) {
      ev.stopPropagation()
      const orderIds = this.holding[`${type}Orders`]
      if (!orderIds) return
      this.$emit('cancelOrder', {
        orderIds,
        order: this.holding.order,
        price: this.data.price
      })
    },
    tradeStock(type) {
      if (!this.isTradable) return
      const data = { limitPrice: this.data.price, orderType: ORDER_TYPE.LMT }
      if (type === 'LMT_BUY') {
        data.action = 'BUY'
      }
      if (type === 'LMT_SELL') {
        data.action = 'SELL'
      }
      this.$emit('tradeStock', data)
    }
  }
}
</script>
<style lang="less">
.dom-table-item {
  transform: none;
  span {
    font-family: Arial, Arial-BoldMT;
    font-weight: bold;
    cursor: default;
    font-size: 12px;
    line-height: 15px;
    color: var(--default-font-color);
    &:nth-of-type(1) {
      background-color: fade(#ff5d21, 15%);
      &:hover.hover {
        background-color: #ff5d21;
      }
    }
    &:nth-of-type(2) {
      &.tradable:hover {
        background-image: none !important;
        background-color: #ff5d21;
      }
    }
    &:nth-last-of-type(2) {
      &.tradable:hover {
        background-image: none !important;
        background-color: #218df2;
      }
    }
    &:nth-last-of-type(1) {
      background-color: fade(#218df2, 15%);
      &:hover.hover {
        background-color: #218df2;
      }
    }
  }
  .cur-price {
    position: relative;
    &:after {
      content: '';
      display: inline-block;
      position: absolute;
      width: 4px;
      height: 4px;
      background-color: var(--active-color);
      left: 8px;
      top: 5px;
    }
  }
  .cost-price {
    border: 1px solid var(--default-font-color);
  }
  .trade-password-wrap {
    position: fixed;
    width: 100%;
    height: 100%;
  }
}
</style>
